import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlService } from '../shared-services/api-url.service';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {

  constructor(
    private readonly http: HttpClient,
    private readonly apiUrlService: ApiUrlService
  ) { }

  getLanguages(payload:any):Observable<any> {
    let param = new HttpParams();
    param = param.append('limit', payload.limit);
    param = param.append('currentPage', payload.currentPage)
    return this.http.get<any>(this.apiUrlService.GET_LANGUAGE_LIST, { params: param});
  }

  getLanguageDetails(id:number):Observable<any> {
    return this.http.get<any>(`${this.apiUrlService.GET_LANGUAGE_DETAILS}/${id}`);
  }

  createLanguage(payload: any):Observable<any> {
    return this.http.post<any>(this.apiUrlService.CREATE_LANGUAGE, payload);
  }

  updateLanguage(id: number, payload: any):Observable<any> {
    return this.http.put<any>(`${this.apiUrlService.UPDATE_LANGUAGE}/${id}`, payload);
  }

  deleteLanguage(id: number) {
    return this.http.delete<any>(`${this.apiUrlService.DELETE_LANGUAGE}/${id}`);
  }

}
